import {
  DecisionPageLayout,
  DecisionSection,
  DecisionSubHeading,
  DecisionList,
  InlineRelatedLinks,
} from "@/components/DecisionPageLayout";
import { Link } from "@/lib/router-compat";

const seo = {
  title: "TMS for Bipolar Depression | Neuro Wellness TMS",
  description:
    "Bipolar depression: learn about TMS therapy and other treatment options. Important clinical considerations for patients with bipolar disorder.",
  canonical: "/tms-for-bipolar-depression",
  keywords:
    "TMS bipolar depression, bipolar depression treatment Florida, TMS bipolar disorder, bipolar TMS therapy",
};

const relatedLinks = [
  { title: "TMS for Depression", href: "/services/depression" },
  { title: "Compare Treatments", href: "/compare-treatments" },
  { title: "Am I a Candidate?", href: "/am-i-a-candidate" },
  {
    title: "Bipolar Disorder Treatment",
    href: "/bipolar-disorder-coral-springs-fl",
  },
];

export default function TmsForBipolarDepression() {
  return (
    <DecisionPageLayout
      seo={seo}
      badge="Bipolar Depression"
      title="TMS for Bipolar Depression"
      subtitle="TMS for bipolar depression involves important clinical considerations. Here's what you need to know before exploring this option."
    >
      <DecisionSection heading="An important distinction">
        <p>
          TMS is FDA-cleared for major depressive disorder, not specifically for
          bipolar depression. However, research into TMS for bipolar depression
          is ongoing, and some providers may consider it in certain clinical
          situations.
        </p>
        <p>
          If you have a bipolar diagnosis, this is something that must be
          discussed with a qualified clinician who can evaluate your specific
          situation. A website cannot determine whether TMS is appropriate for
          you.
        </p>
      </DecisionSection>

      <DecisionSection heading="What to know">
        <DecisionList
          items={[
            "TMS is FDA-cleared for major depressive disorder, not bipolar depression specifically",
            "Some insurance plans, including FEP, classify TMS for bipolar disorder as investigational",
            "Bipolar depression requires careful clinical evaluation — a mood stabilizer may need to be in place",
            "Your prescriber should be involved in any decision about TMS for bipolar depression",
            "Coverage for off-label use is not guaranteed and varies by plan",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="Your next step">
        <p>
          If you have bipolar disorder and are exploring treatment options for
          depression, a consultation is the right place to start. We'll review
          your diagnosis, medications, and treatment history, and discuss what
          options may be clinically appropriate.
        </p>
        <p>
          Call{" "}
          <a
            href="tel:9548279793"
            className="text-accent font-semibold hover:underline"
          >
            (954) 827-9793
          </a>{" "}
          or{" "}
          <Link to="/contactus" className="text-accent hover:underline">
            schedule a consultation
          </Link>
          .
        </p>
      </DecisionSection>

      <InlineRelatedLinks heading="Related Pages" links={relatedLinks} />
    </DecisionPageLayout>
  );
}
